export async function loadDocsComponent(filename: string): Promise<any> {
  return import(`!!@mdx-js/loader!../../docs/${filename}`)
}
